export const SALES_EFS = 'sales_efs';
